export default __webpack_public_path__ + "static/media/330_dummy2016-immobilien01-mobile-de.71cc6931.png";